import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RestyleOrderDialogData {
  message?: string;
  invoiceNumber?: string;
}

@Component({
  selector: 'app-restyle-order-dialog',
  template: `
    <h2 mat-dialog-title>RE-STYLE ORDER</h2>
    <mat-dialog-content>
      <p class="restyle-dialog-message">
        {{
          data?.message ||
            'Customer returned the frame after wearing. This creates a new job and marks the original as re-styled. No refund or store credit will be issued.'
        }}
      </p>
      <p *ngIf="data?.invoiceNumber" class="restyle-dialog-invoice">
        Original invoice: {{ data.invoiceNumber }}
      </p>
      <mat-checkbox [(ngModel)]="frameSellable" class="restyle-dialog-checkbox">
        Frame is in sellable condition
      </mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()"
      >
        RE-STYLE
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .restyle-dialog-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .restyle-dialog-invoice {
        margin: 0 0 12px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
      .restyle-dialog-checkbox {
        display: block;
        white-space: normal;
      }
    `,
  ],
})
export class RestyleOrderDialogComponent {
  frameSellable = false;

  constructor(
    public dialogRef: MatDialogRef<RestyleOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RestyleOrderDialogData
  ) {}

  get canConfirm(): boolean {
    return this.frameSellable;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(true);
  }
}
